
const emailTemplates = {
  callSheetModelHmuAgency: 'sstudio_callsheet_model_hmu_agency',
  callSheetModelHmuNoAgency: 'sstudio_callsheet_model_hmu_no_agency',
  callSheetGeneralAgency: 'sstudio_callsheet_general_agency',
  callSheetGeneralNoAgency: 'sstudio_callsheet_general_no_agency',
  callSheetGeneralNoContactAgency: 'sstudio_callsheet_general_no_contact_agency',
  callSheetGeneralNoContactNoAgency: 'sstudio_callsheet_general_no_contact_no_agency',
}

export default emailTemplates;
